export class KDSReportOutput {
    report_type: string;
    from_date: string;
    to_date: string;
    medium: string;
    user_id: number;
    report_format: string;
    report_output: string; 
    report_email: string;       
}